import { landingPage } from "./ids.js";
import type { Attribution, KeyValueStore } from "./types.js";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

/**
 * Build the attribution block from the current page. UTM params come off the query string;
 * referrer is the document referrer (nulled when it's same-origin, i.e. internal navigation);
 * landing_page is the first URL of the session (sticky via the store). Fields are emitted only
 * when present so the envelope stays sparse, matching the fixture.
 */
export function buildAttribution(
  store: KeyValueStore,
  currentUrl: string,
  referrer: string,
  isNewSession: boolean,
): Attribution {
  const url = new URL(currentUrl);
  const params = url.searchParams;
  const attribution: Attribution = {};

  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) attribution[key] = value;
  }

  const ref = referrer && !sameOrigin(referrer, url.origin) ? referrer : null;
  if (ref) attribution.referrer = ref;

  attribution.landing_page = landingPage(store, currentUrl, isNewSession);
  return attribution;
}

function sameOrigin(referrer: string, origin: string): boolean {
  try {
    return new URL(referrer).origin === origin;
  } catch {
    return false;
  }
}
